import React, { ComponentProps } from 'react';
import { asView } from '../../../_lib/ViewFetcher';
import { PageType } from '../../../types/api/PageType';
import { PageLeadDefault } from '../../../_lib/components/PageLead';

type PageLeadBlockDefaultProps = {
  leadText: string;
  title: string;
  pageType: PageType;
  categories: string[];
};

function PageLeadBlockDefault(props: PageLeadBlockDefaultProps) {
  return <PageLeadDefault {...props} />;
}

export const PageLeadBlockDefaultView = asView(PageLeadBlockDefault);
export type PageLeadBlockDefaultView = ComponentProps<typeof PageLeadBlockDefaultView>;
